import React, { useState } from 'react';

import css from './BookCover.module.css';

const BookCover = ({ title, author, coverUrl }) => {
  const [hasError, setHasError] = useState(false);
  const showImage = coverUrl && !hasError;

  return (
    <div className={css.root}>
      {showImage ? (
        <img src={coverUrl} alt={`Cover of ${title}`} onError={() => setHasError(true)} />
      ) : (
        <div className={css.fallback}>
          <span className={css.brand}>PageHop</span>
          <strong>{title}</strong>
          <span>{author}</span>
        </div>
      )}
    </div>
  );
};

export default BookCover;